/**
 * The rows to write when an item is dragged from one position to another.
 *
 * Shared by every draggable list in Momentum — website sections, course modules
 * — because they order the same way: a `sortOrder` on the row, and a list read
 * back in that order.
 *
 * A neighbour swap can't express "drag the first one to the end", so this
 * renumbers the list 0..n-1 in the new order. Renumbering rather than slotting a
 * value between two neighbours also repairs a list whose rows share a
 * `sort_order` — rows written before the migration that added it, or a
 * half-failed swap — which is the state that made the old arrows look dead: the
 * writes landed, and the list came back in the same order because the orders
 * were equal.
 *
 * Returns only the rows whose position actually changed, so dragging one item up
 * by one costs two writes rather than eight. Pure, so it can be tested without a
 * Supabase round trip.
 */
export function reorderWrites(list = [], from, to) {
  if (from < 0 || to < 0 || from >= list.length || to >= list.length || from === to) return [];
  const next = [...list];
  next.splice(to, 0, next.splice(from, 1)[0]);
  const writes = [];
  next.forEach((row, i) => {
    if (row.sortOrder !== i) writes.push({ ...row, sortOrder: i });
  });
  return writes;
}
